"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRouterDom = require("react-router-dom");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var R = _interopRequireWildcard(require("ramda"));
var _MenuList = _interopRequireDefault(require("./MenuList.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _excluded = ["id", "children", "menuItems", "position", "expanded", "itemId", "ignoreSingleItemLogic", "itemsProps", "isActionDisabled", "disabled", "ariaLabel", "item", "optionsTracking"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ICON_SIZE = 28;
var getListItemLabel = function getListItemLabel(item) {
  var _ref = item || {},
    name = _ref.name,
    icon = _ref.icon,
    showIconAsLabel = _ref.showIconAsLabel;
  if (!showIconAsLabel) return name;
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: icon,
    size: ICON_SIZE
  });
};
var getListItemClass = function getListItemClass(showIconAsLabel, isActionDisabled) {
  return (0, _classnames["default"])({
    'single-list-item': true,
    disabled: isActionDisabled,
    'icon-label': showIconAsLabel
  });
};
var MenuList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MenuList, _React$PureComponent);
  var _super = _createSuper(MenuList);
  function MenuList(props) {
    var _this;
    _classCallCheck(this, MenuList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMenuVisibility", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
      if (typeof _this.props.onToggle === 'function') _this.props.onToggle(!_this.state.isExpanded);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSingleMenuItem", function (menuItems, itemId, isActionDisabled, itemProps, item) {
      var firstMenuItem = R.prop(0, menuItems);
      var routerLinkBase = R.prop('routerLinkBase', firstMenuItem);
      var showIconAsLabel = R.prop('showIconAsLabel', firstMenuItem);
      var link = R.prop('link', firstMenuItem);
      var _onClick = R.prop('onClick', firstMenuItem);
      var contextMenuProps = R.prop(R.prop('key', firstMenuItem), itemProps) || {};
      if (routerLinkBase && itemId) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({}, contextMenuProps, {
          className: getListItemClass(showIconAsLabel, isActionDisabled),
          to: "".concat(routerLinkBase, "/").concat(itemId)
        }), getListItemLabel(firstMenuItem));
      }
      return /*#__PURE__*/_react["default"].createElement("a", _extends({}, contextMenuProps, {
        className: getListItemClass(showIconAsLabel, isActionDisabled),
        href: link,
        onClick: function onClick() {
          return _onClick(itemId, item);
        }
      }), getListItemLabel(firstMenuItem));
    });
    _this.state = {
      isExpanded: props.expanded || false
    };
    return _this;
  }
  _createClass(MenuList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        children = _this$props.children,
        menuItems = _this$props.menuItems,
        position = _this$props.position,
        expanded = _this$props.expanded,
        itemId = _this$props.itemId,
        ignoreSingleItemLogic = _this$props.ignoreSingleItemLogic,
        itemsProps = _this$props.itemsProps,
        isActionDisabled = _this$props.isActionDisabled,
        disabled = _this$props.disabled,
        ariaLabel = _this$props.ariaLabel,
        item = _this$props.item,
        optionsTracking = _this$props.optionsTracking,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "menulist-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], _extends({
        id: id,
        isExpanded: isExpanded,
        position: position
      }, otherProps), R.length(menuItems) === 1 && !ignoreSingleItemLogic ? this.handleSingleMenuItem(menuItems, itemId, isActionDisabled, itemsProps, item) : !disabled && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-toggler",
        onClick: this.toggleMenuVisibility,
        onKeyDown: this.toggleMenuVisibility,
        role: "button",
        "aria-label": ariaLabel || 'Expand menu',
        tabIndex: "0"
      }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "close-button",
        icon: "ion-close-circled",
        size: 24,
        onClick: this.toggleMenuVisibility,
        "aria-label": "Close menu"
      }) : children), isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
        className: "list-container"
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
        closeMenu: this.handleClickOutside,
        optionsTracking: optionsTracking,
        items: menuItems,
        itemId: itemId,
        itemsProps: itemsProps
      })))));
    }
  }]);
  return MenuList;
}(_react["default"].PureComponent);
MenuList.propTypes = {
  /** Html id */
  id: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  expanded: _propTypes["default"].bool,
  ignoreSingleItemLogic: _propTypes["default"].bool,
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onToggle: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(['top-right', 'top-left', 'bottom-left', 'bottom-right']),
  itemId: _propTypes["default"].string,
  itemsProps: _propTypes["default"].shape({}),
  disabled: _propTypes["default"].bool,
  isActionDisabled: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string,
  item: _propTypes["default"].shape({}),
  optionsTracking: _propTypes["default"].func
};
MenuList.defaultProps = {
  disabled: false,
  id: '',
  expanded: undefined,
  ignoreSingleItemLogic: false,
  onToggle: undefined,
  position: 'top-right',
  itemId: '',
  item: {},
  itemsProps: undefined,
  isActionDisabled: false,
  ariaLabel: '',
  optionsTracking: function optionsTracking() {}
};
MenuList.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggleMenuVisibility",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleSingleMenuItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "menuItems",
      "type": null
    }, {
      "name": "itemId",
      "type": null
    }, {
      "name": "isActionDisabled",
      "type": null
    }, {
      "name": "itemProps",
      "type": null
    }, {
      "name": "item",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "MenuList",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Html id",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "expanded": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "ignoreSingleItemLogic": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onToggle": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "position": {
      "defaultValue": {
        "value": "'top-right'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top-right'",
          "computed": false
        }, {
          "value": "'top-left'",
          "computed": false
        }, {
          "value": "'bottom-left'",
          "computed": false
        }, {
          "value": "'bottom-right'",
          "computed": false
        }]
      },
      "required": false
    },
    "itemId": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "item": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "itemsProps": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "isActionDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "optionsTracking": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "menuItems": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": true
    }
  }
};
var _default = (0, _reactClickOutside["default"])(MenuList);
exports["default"] = _default;